import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { compose, graphql } from 'react-apollo'
import LoadingButton from '../../common/LoadingButton'
import Button from '../../common/Button'
import DestroyDocumentBucket from '../queries/DestroyDocumentBucket'
import DestroyDocumentFiles from '../queries/DestroyDocumentFiles'
import DocumentsQuery from '../queries/DocumentsQuery'
import FadeInUpWrapper from '../../common/FadeInUpWrapper'
import CacheUtil from '../../common/utils/CacheUtil'


const Container = styled(FadeInUpWrapper)`
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  width: 420px;
  padding: 30px;
  border: 1px solid #b4b5b6;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`
const Cancel = Button.extend`
  background: #b4b5b6;
  margin-left: 5px;
`
const Delete = styled(LoadingButton)`
  margin-right: 5px;
`
class DeleteBucketModal extends React.Component {
  constructor() {
    super()
    this.state = {
      isLoading: false
    }
  }
  static propTypes = {
    destroyDocumentBucket: PropTypes.func,
    destroyDocumentFiles: PropTypes.func,
    document: PropTypes.shape({
      rid: PropTypes.number.isRequired
    }),
    loanId: PropTypes.number.isRequired,
    name: PropTypes.string,
    resourceType: PropTypes.string.isRequired,
    rid: PropTypes.number.isRequired,
    toggleModal: PropTypes.func
  }
  onDeleteClick = () => {
    const { type } = this.props.document
    if (type === 'Document::T4506t') {
      this.destroyFiles()
    } else {
      this.destroyBucket()
    }
  }
  destroyFiles = async () => {
    const { destroyDocumentFiles, rid, loanId, resourceType, entityId, toggleModal } = this.props
    const { files } = this.props.document
    await this.setState({
      isLoading: true
    })
    try {
      await destroyDocumentFiles({
        variables: {
          input: {
            documentId: rid,
            filenames: files.map(f => f.name)
          }
        },
        update: (store, { data: { destroyDocumentFiles: { document } } }) => {
          const data = store.readQuery({ query: DocumentsQuery, variables: { rid: loanId } })
          const entity = CacheUtil.findEntityById(data.loan, entityId, resourceType)
          const idx = entity.documents.findIndex(doc => doc.rid === rid)
          if (idx > -1) {
            entity.documents[idx] = document
          }
          store.writeQuery({ query: DocumentsQuery, variables: { rid: loanId }, data })
        }
      })
      toggleModal()
    } catch (err) {
      console.log(err)
    }
  }
  destroyBucket = async () => {
    const { destroyDocumentBucket, rid, loanId, toggleModal, entityId, resourceType, isAffiliate, resetClientStore } = this.props
    await this.setState({
      isLoading: true
    })
    try {
      await destroyDocumentBucket({
        variables: {
          input: {
            documentId: rid
          }
        },
        update: store => {
          const data = store.readQuery({ query: DocumentsQuery, variables: { rid: loanId } })
          let entity
          if (isAffiliate) {
            entity = CacheUtil.findAffiliateEntityById(data.loan, entityId)
          } else {
            entity = CacheUtil.findEntityById(data.loan, entityId, resourceType)
          }
          entity.documents = entity.documents.filter(({ rid: docId }) => rid !== docId)
          store.writeQuery({ 
            query: DocumentsQuery,
            variables: { rid: loanId },
            data
          })
          if (resetClientStore) {
            resetClientStore()
          }
        }
      })
      toggleModal()
    } catch (err) {
      console.log(err)
    }
  }
  onCancelClick = () => {
    this.props.toggleModal()
  }
  render() {
    const { name } = this.props
    const { isLoading } = this.state
    return (
      <Container id="delete_bucket_modal">
        <h3>Are you sure you want to delete the document {name}?</h3>
        <ButtonContainer>
          <Delete id="delete_bucket_save" onClick={this.onDeleteClick} loading={isLoading}>
            Delete
          </Delete>
          <Cancel id="cancel_delete_bucket" onClick={this.onCancelClick}>
            Cancel
          </Cancel>
        </ButtonContainer>
      </Container>
    )
  }
}
export default compose(
  graphql(DestroyDocumentBucket, {
    name: 'destroyDocumentBucket'
  }),
  graphql(DestroyDocumentFiles, {
    name: 'destroyDocumentFiles'
  })
)(DeleteBucketModal)
